import { useState } from 'react'
import './HomePage.css'
import {
  Table,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableCell,
  TextField
} from '@wwnds/react';

const HomePage = ({ directories }) => {

  const [searchTerm, setSearchTerm] = useState("")
  const handleSearch = (e) => {
    setSearchTerm(e.target.value)
  }

  return (
    <div className="homepage-container">
      <TextField
        description="Enter search term"
        value={searchTerm}
        onChange={handleSearch}
      >
      </TextField>

      <Table>
        <TableHeader>
          <TableHeaderCell>Project</TableHeaderCell>
          <TableHeaderCell>Interactive</TableHeaderCell>
          <TableHeaderCell>Local</TableHeaderCell>
          <TableHeaderCell>Dev</TableHeaderCell>
          <TableHeaderCell>Prod</TableHeaderCell>
        </TableHeader>
        {directories.filter(el => el.path.includes(searchTerm)).map(element => (
          <TableRow>
            <TableCell>{`${element.path.split("/")[0]}`}</TableCell>
            <TableCell>{`${element.path.split("/")[1]}`}</TableCell>
            <TableCell><a href={`http://localhost:3000/#/${element.path}`} target="_blank" rel="noreferrer">local</a></TableCell>
            <TableCell><a href={`https://video-interactive-listening-guides-wwnorton-medi-bdc68b78faed43.gitlab.io/#/${element.path}`} target="_blank" rel="noreferrer">dev</a></TableCell>
            <TableCell><a href={`https://dkgmu2qb4qojy.cloudfront.net/index.html#/${element.path}`} target="_blank" rel="noreferrer"><b>prod</b></a></TableCell>
          </TableRow>
        ))}
      </Table>
    </div>
  )
}

export default HomePage;